module.exports = __webpack_public_path__ + "static/media/455JamesPBrawleyDrNW_2018-06-12_86.2400f6f7.jpg";